import messageHelper from '../../../../components/Common/Message/MessageHelper';
import httpClient from '../../common/httpClient';

const getRegimeDisplayName = (regime: string): string => {

    let regimesString = localStorage.getItem('regimes');

    if (!regimesString) {
        messageHelper.showMesage(`No value for regime ${regime}`);

        return '';
    }

    let regimes = new Map<string, string>(Object.entries(JSON.parse(regimesString)));

    return regimes.get(regime) as string;
}

const getRegime = (regimeDisplayName: string): string => {

    let regimesString = localStorage.getItem('regimes');

    if (!regimesString) {
        messageHelper.showMesage(`No value for regime ${regimeDisplayName}`);

        return '';
    }

    let regimes = JSON.parse(regimesString);

    for (const key in regimes) {

        if (regimes[key] === regimeDisplayName) {
            return key;
        }
    }
    return '';
}

const getRegimes = (): Map<string, string> => {

    let regimesString = localStorage.getItem('regimes') as string;

    return new Map<string, string>(Object.entries(JSON.parse(regimesString)));
}

const getRegimesWithoutDeprecated = (): Map<string, string> => {

    let regimesString = localStorage.getItem('regimes') as string;

    let regimes = new Map<string, string>(Object.entries(JSON.parse(regimesString)));

    const deprecatedRegimes = ['MiFIR Cb', 'ASIC', 'EMIR'];

    deprecatedRegimes.forEach((r) => {

        regimes.delete(r);
    });

    return regimes;
}

const initialiseRegimes = async ():Promise<Map<string, string>> => {

    let res = await httpClient.get<Map<string, string>>('report/regimes');

    localStorage.setItem('regimes', JSON.stringify(res.data));

    return res.data;
}

const hasRegimeSubregimes = (regime: string): boolean => {

    return regime === "EMIR REFIT";
}

const reportRegimeHelper = {
    getRegimeDisplayName,
    getRegime,
    hasRegimeSubregimes,
    getRegimes,
    getRegimesWithoutDeprecated,
    initialiseRegimes
};

export default reportRegimeHelper;
